import { Grid } from '@material-ui/core'
import { HourglassEmpty } from '@material-ui/icons'
import { useSelector } from 'react-redux'
import customCircleCheck from '../../../assets/img/icons/ic-check-circle.png'

const ProjectCharges = () => {
  const { project } = useSelector((state) => state.projectDetails)

  return (
    <>
      <h2 className="m-b-32">Project cost</h2>

      {project.charges.map((charge, index) => (
        <Grid container spacing={3} key={index}>
          <Grid item sm={6} xs={12}>
            <div className="flex">
              <div style={{ width: 60 }}>
                {index === 0 ? 'Initial: ' : 'Added: '}
              </div>
              <div>
                {charge.price.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          </Grid>
          <Grid item sm={6} xs={12}>
            {charge.isPaid ? (
              <div className="paid">
                <img
                  src={customCircleCheck}
                  alt="Circle Check"
                  style={{ width: 14 }}
                />
                Paid
              </div>
            ) : (
              <>
                <HourglassEmpty style={{ width: 14 }} />
                Pending {project.purchaseOrderNumber ? 'AE review' : 'payment'}
              </>
            )}
          </Grid>
        </Grid>
      ))}
    </>
  )
}

export default ProjectCharges
